import API from "@fetcher/fetcher";
import { ELoadingOptions } from "@modules/loader/useLoader.hook";

const BASE_URL = "/auth";

interface IToken {
  token: string;
}

export class AuthAPI {
  static register = async (email: string) =>
    API.post<{ code: string }>(
      `${BASE_URL}/register`,
      { email },
      ELoadingOptions.NONE,
    );

  static login = async (email: string) =>
    API.post<{ code: string }>(
      `${BASE_URL}/login`,
      { email },
      ELoadingOptions.NONE,
    );

  static verifyOTP = async (code: string) =>
    API.post<IToken>(`${BASE_URL}/otp`, { code }, ELoadingOptions.NONE);

  static authorizeDiscord = async () => {
    return API.get<{ url: string }>(`${BASE_URL}/discord/authorize`).then(
      (res) => res.data.url,
    );
  };

  static loginDiscord = (code: string) => {
    return API.get<IToken>(`${BASE_URL}/discord/callback`, { code });
  };

  static authorizeGoogle = async () => {
    return API.get<{ url: string }>(`${BASE_URL}/google/authorize`).then(
      (res) => res.data.url,
    );
  };

  static loginGoogle = (code: string) => {
    return API.get<IToken>(`${BASE_URL}/google/callback`, { code });
  };
}
